<template>
  <div id="app">
    <HelloWorld msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import { axios } from '@/utils/index';

export default {
  name: 'app',
  components: {
    HelloWorld
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  min-width: 1200px;
}
html,body,#app {
  height: 100%;
}
* {
  margin: 0;
  border: none;
  outline: none;
  box-sizing: border-box!important;
}
span {
  display: inline-block;
}
.g-scroll{
  height: 100%;
}
</style>
